<template>
  <div class="container">
    <div class="box col-md-5">
      <div>
        <h1>Login Atendente</h1>
        <p>Para acessar essa página é necessário confirmar a senha do SIVA.</p>
      </div>

      <div class="margin-t20">
        <div class="alert alert-danger margin-b10" v-show="errorMessage">
          {{ errorMessage }}
        </div>
        <form
          action="index.html"
          @submit.prevent="doLoginAtendente"
          v-async="loading"
          novalidate
        >
          <div
            class="form-group"
            :class="{ 'has-error': errors.has('password') }"
          >
            <label>Senha</label>
            <input
              class="form-control small"
              type="password"
              name="password"
              v-model="passwordSiva"
              v-validate
              data-vv-rules="required"
              maxlength="40"
            />
            <div class="help-block">{{ errors.first("password") }}</div>
          </div>
          <div class="text-center">
            <button
              id="btn-login"
              class="btn btn-lg btn-purple"
              type="submit"
              name="button"
            >
              Continuar
            </button>
            <i class="icon-circle-right align-icon"></i>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Auth from "../../services/auth";
export default {
  data() {
    return {
      accessToken: undefined,
      passwordSiva: undefined,
      loading: undefined,
      errorMessage: ''
    };
  },
  computed: {},
  created() {
    this.accessToken = this.$route.query.GZK;
    // const userBackofficeId = this.$route.query.PFL;

    // Auth.loginAtendente(this.passwordSiva,access_token).then((r) => {
    //   // this.$router.push({name: 'plans'});
    // });
  },

  methods: {
    doLoginAtendente() {
    Auth.loginAtendente(this.passwordSiva, this.accessToken).then((r) => {
      
      this.$router.push({name: 'plans'});
    }).catch(() =>{
      this.errorMessage = 'Ocorreu um erro ao autenticar a sessão.'
    })
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// login-atendente.vue?76c83a57